module.exports = __webpack_public_path__ + "cafab79c00240be8ccc02216c0c09cfd.svg";